import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent } from 'vue';
import PracticeSelector from '@/pages/profile/practice-selector.vue';
import { useApiErrorToast } from '@/modules/useApiErrorToast';
import { apprenticePeriodRules, practiceValidator } from '@/utils/profileUtils';
import { useRepositories } from '@/plugins/repositories';
import { useTelemetry } from '@/plugins/telemetry';
import { useAuth } from '@/plugins/auth';
var stringToNumber = function stringToNumber(numString) {
  if (numString === '') return null;
  var numberedString = Number(numString);
  if (isNaN(numberedString)) return null;
  return numberedString;
};
var isValidSelection = function isValidSelection(obj) {
  if (obj.withExperience && obj.experienceId === -1) {
    return false;
  }
  return obj.practiceId !== -1;
};
export default defineComponent({
  components: {
    PracticeSelector: PracticeSelector
  },
  setup: function setup() {
    var _user$profile$apprent;
    var telemetry = useTelemetry();
    var route = useRoute();
    var repositories = useRepositories();
    var _useApiErrorToast = useApiErrorToast(),
      showRetriableErrorToast = _useApiErrorToast.showRetriableErrorToast;
    var loadingMe = ref(true);
    var editing = ref(false);
    var apprenticePeriod = ref('');
    var apprenticePeriodValid = ref(false);
    var practicesValid = ref(false);
    var practices = ref([]);
    var availablePracticeOptions = ref([]);
    var experienceOptions = ref([]);
    var organizationType = ref(null);
    var loadingOrganizationType = ref(true);
    repositories.users.getOrganizationType().then(function (res) {
      organizationType.value = res;
      loadingOrganizationType.value = false;
    });
    var isLawOffice = computed(function () {
      return organizationType.value === 'law-office';
    });
    var isProfessionalOffice = computed(function () {
      return organizationType.value === 'professional-office';
    });
    var practiceLabel = computed(function () {
      return isLawOffice.value ? 'プラクティス' : '主なリサーチ分野';
    });
    var submitButtonDisabled = computed(function () {
      return isProfessionalOffice ? !practicesValid : !apprenticePeriodValid || !practicesValid;
    });
    var blankPracticeOption = {
      name: '選択してください',
      id: -1,
      isExperienceRequired: false
    };
    var blankExperienceOption = {
      name: '選択してください',
      id: -1
    };
    var loadingPracticesForUserProfile = ref(true);
    repositories.users.listPracticesForUserProfile().then(function (res) {
      availablePracticeOptions.value = res.practices;
      experienceOptions.value = res.experiences;
      loadingPracticesForUserProfile.value = false;
    });
    var validate = function validate(practices) {
      practicesValid.value = practiceValidator(practices);
    };
    var _useAuth = useAuth(),
      user = _useAuth.user;
    apprenticePeriod.value = ((_user$profile$apprent = user.profile.apprenticePeriod) === null || _user$profile$apprent === void 0 ? void 0 : _user$profile$apprent.toString()) || '';
    practices.value = user.profile.practices;
    loadingMe.value = false;
    validate(practices.value);
    var addPractice = function addPractice() {
      practices.value = [].concat(_toConsumableArray(practices.value), [{
        withExperience: false,
        practiceId: -1,
        practiceName: '選択してください'
      }]);
      validate(practices.value);
    };
    var deletePractice = function deletePractice(index) {
      practices.value = practices.value.filter(function (_, _index) {
        return index !== _index;
      });
      validate(practices.value);
    };
    var submit = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _user$profile$apprent2;
        var _useAuth2, user, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              practices.value = practices.value.filter(isValidSelection);
              _context.p = 1;
              _context.n = 2;
              return repositories.users.putUserProfile(stringToNumber(apprenticePeriod.value), practices.value.map(function (selection) {
                return selection.withExperience ? {
                  practiceId: selection.practiceId,
                  experienceId: selection.experienceId
                } : {
                  practiceId: selection.practiceId
                };
              }));
            case 2:
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              showRetriableErrorToast('プロフィールの送信に失敗しました');
              telemetry.sendErrorTelemetry(_t, route);
              return _context.a(2);
            case 4:
              _useAuth2 = useAuth(), user = _useAuth2.user;
              apprenticePeriod.value = ((_user$profile$apprent2 = user.profile.apprenticePeriod) === null || _user$profile$apprent2 === void 0 ? void 0 : _user$profile$apprent2.toString()) || '';
              practices.value = user.profile.practices;
              validate(practices.value);
              editing.value = false;
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3]]);
      }));
      return function submit() {
        return _ref.apply(this, arguments);
      };
    }();
    var updatePracticeIdHandler = function updatePracticeIdHandler(targetIndex, practiceId) {
      practices.value = practices.value.map(function (practice, index) {
        if (index !== targetIndex) return practice;
        var practiceOption = availablePracticeOptions.value.find(function (option) {
          return option.id === practiceId;
        }) || blankPracticeOption;
        if (practiceOption.isExperienceRequired) {
          if (practice.withExperience) {
            return _objectSpread(_objectSpread({}, practice), {}, {
              practiceId: practiceOption.id,
              practiceName: practiceOption.name
            });
          }
          return {
            withExperience: true,
            practiceId: practiceOption.id,
            practiceName: practiceOption.name,
            experienceId: blankExperienceOption.id,
            experienceName: blankExperienceOption.name
          };
        }
        return {
          withExperience: false,
          practiceId: practiceOption.id,
          practiceName: practiceOption.name
        };
      });
      validate(practices.value);
    };
    var updateExperienceIdHandler = function updateExperienceIdHandler(targetIndex, experienceId) {
      practices.value = practices.value.map(function (practice, index) {
        if (index !== targetIndex || practice.withExperience === false) return practice;
        var experienceOption = experienceOptions.value.find(function (option) {
          return option.id === experienceId;
        }) || blankPracticeOption;
        return _objectSpread(_objectSpread({}, practice), {}, {
          experienceId: experienceOption.id,
          experienceName: experienceOption.name
        });
      });
      validate(practices.value);
    };
    var practiceOptions = computed(function () {
      return availablePracticeOptions.value.filter(function (option) {
        return !practices.value.some(function (p) {
          return p.practiceId === option.id;
        });
      });
    });
    var loading = computed(function () {
      return loadingMe.value || loadingOrganizationType.value || loadingPracticesForUserProfile.value;
    });
    return {
      editing: editing,
      apprenticePeriod: apprenticePeriod,
      practiceOptions: practiceOptions,
      availablePracticeOptions: availablePracticeOptions,
      experienceOptions: experienceOptions,
      addPractice: addPractice,
      deletePractice: deletePractice,
      submit: submit,
      practices: practices,
      updatePracticeIdHandler: updatePracticeIdHandler,
      updateExperienceIdHandler: updateExperienceIdHandler,
      apprenticePeriodRules: apprenticePeriodRules,
      practiceLabel: practiceLabel,
      apprenticePeriodValid: apprenticePeriodValid,
      practicesValid: practicesValid,
      loading: loading,
      isProfessionalOffice: isProfessionalOffice,
      submitButtonDisabled: submitButtonDisabled
    };
  }
});